import { useCallback, useMemo } from "react"

import eq from "lodash-es/eq"
import { type NavigateFunction, useNavigate } from "react-router-dom"

import { INDEX_URL } from "@/constants"
import { coachCalendarSetupRoutes } from "@/routes"
import type { TEmptyCallback } from "@/shared/types/functions"

/**
 * @deprecated is used for all pages; remove A$AP
 */
function useCoachCalendarOrderNavigation(
    order: number
): ReturnType<(order: number) => { navigateByOrder: TEmptyCallback; nextOrderStep: string }> {
    const navigate: NavigateFunction = useNavigate()

    const nextOrderStep: string = useMemo((): string => {
        if (!eq(order, coachCalendarSetupRoutes.length)) return coachCalendarSetupRoutes[order].path

        return INDEX_URL
    }, [order])

    const navigateByOrder: TEmptyCallback = useCallback((): void => {
        navigate(nextOrderStep)
    }, [navigate, nextOrderStep])

    return { navigateByOrder, nextOrderStep }
}

export { useCoachCalendarOrderNavigation }
